import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";


const initialState = {
    incomeStatement: {
        id: null,
        isLoading: false,
        data: null
    },
    balanceSheet: {
        id: null,
        isLoading: false,
        data: null
    },
    error: null
};


export default function reportReducer(state = initialState, action) {
    var newState = { ...state };

    switch (action.type) {
        case Constants.REQUEST_INCOME_STATEMENT_REPORT:
            newState.incomeStatement = { ...newState.incomeStatement, isLoading: true };
            return newState;
        case Constants.RECEIVE_INCOME_STATEMENT_REPORT:
            newState.incomeStatement = {
                ...newState.incomeStatement,
                isLoading: false,
                data: action.payload
            };

            return newState;

        case Constants.REQUEST_BALANCE_SHEET_REPORT:
            newState.balanceSheet = { ...newState.balanceSheet, isLoading: true };
            return newState;

        case Constants.RECEIVE_BALANCE_SHEET_REPORT:
            newState.balanceSheet = {
                ...newState.balanceSheet,
                isLoading: false,
                data: action.payload
            };

            return newState;

        case Constants.RESET_REPORT:
            newState.incomeStatement = {
                ...newState.incomeStatement,
                data: null
            }
            newState.balanceSheet = {
                ...newState.balanceSheet,
                data: null
            };
            return newState;

        default:
            return newState;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReportReducer.js